var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Site",attrs:{"id":"app"}},[(_vm.header_show)?_c('head-banner'):_vm._e(),_c('router-view',{staticClass:"Site-content",on:{"public_header":_vm.public_header,"public_footer":_vm.public_footer}}),(_vm.footer_show)?_c('foot-banner'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }